App.controller('HealthPzuwStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$timeout', 'popUpService', function ($scope, $sce, $state, $http, packageService, $timeout, popUpService) {
    $scope.page = 'healthInsurancePzuw_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Opieka medyczna TUW PZUW';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    $timeout(function () {
        if (!$('.menu.menu_healthPzuw').hasClass('open')) {
            $('a[target=".menu_healthPzuw"]').trigger('click');
        }
    }, 100);

    setTimeout(function () {
        window.location.href = "/";
    }, 1);

    popUpService.showPopUpBigInfo('', '', 'Przystępowanie do nowego programu zdrowotnego będzie możliwe od 4 grudnia.');

    $scope.currentDate = new Date();
}]);
